import GlobalEditor from "./src/main.vue";

GlobalEditor.install = (Vue) => {
    Vue.component(GlobalEditor.name, GlobalEditor);
}

export default GlobalEditor;